import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_40 } from '../../../../../Button'

import { QA_NAME_LINK_REQUESTS_ACTION } from './moreActions.constants'

export function useMoreActions({ onOpenAttachServiceRequest }) {
  const { t } = useTranslation()

  const actions = [
    {
      Component: Button.Flat,
      height: BUTTON_HEIGHT_40,
      isGrey: true,
      key: 'attach-service-request',
      qaName: QA_NAME_LINK_REQUESTS_ACTION,
      text: t('Newsboard.AttachServiceRequestActionOptionKey'),
      tooltip: t('Newsboard.AttachServiceRequestActionOptionTooltipKey'),
      onClick: onOpenAttachServiceRequest,
    },
  ]

  return { moreActions: actions }
}
